import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Divider, Form, Input, Radio, Space } from 'antd';
import { RadioChangeEvent } from 'antd/es/radio/interface';

import { TemplateType } from '@/components/SearchTablePage/types/tplTypes';
import { QueryObjectType } from '@/components/SearchTablePage/utils/commonInterface';
import { useI18nContext } from '@/i18n/I18n';
import { IPermission } from '@/services/types/apiManagement';
import { isValidIP, preSql } from '@/utils/ruleValidate';

import { Permission } from '../Permission';

const { TextArea } = Input;

export interface ICreateApi {
  bindIps: string;
  line1: undefined;
  line2: undefined;
  permissions: React.Key[] | Partial<IPermission>;
  readOnly: boolean;
  note?: string;
}
export interface ISearchCreateApi {
  bindIps: string;
  permissions: Partial<IPermission>;
  readOnly: boolean;
  note: string;
}
export interface IThirdAppName {
  'read-only': boolean;
  name: string;
  value: string;
}

export const useCreateApiHelper = () => {
  const [$t] = useI18nContext();
  const getFormItems: (
    readOnly: boolean,
    onReadOnlyChange: (e: RadioChangeEvent) => void,
    disabled?: boolean,
  ) => QueryObjectType[] = (readOnly, onReadOnlyChange, disabled = false) => {
    const readOnlyOption = [
      {
        key: false,
        value: $t('readWrightP0'),
      },
      {
        key: true,
        value: $t('onlyReadP0'),
      },
    ];
    const formItemConfig: QueryObjectType[] = [
      {
        id: 'readOnly',
        tpl: TemplateType.Radio,
        label: $t('apiPermissions'),
        options: readOnlyOption,
        disabled,
        componentProps: {
          onChange: onReadOnlyChange,
        },
        formItemProps: {
          style: { marginBottom: 15 },
        },
      },
      {
        id: 'permissions',
        tpl: TemplateType.Custom,
        formItemProps: {
          rules: [
            {
              required: true,
              message: $t('Please set the permission parameters for the key'),
            },
          ],
        },
        render: () => {
          return <Permission readOnly={readOnly} disabled={disabled} />;
        },
      },
    ];
    return formItemConfig;
  };
  return { getFormItems };
};
